/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} ShiftRecordAddedCommentType
 * @property {ShiftRecordBreakDTO[]} breaks - List of breaks
 * @property {boolean} isRestBreakCompliant - Did candidate receive adequate rest breaks
 */

import ShiftRecordBreakDTO from './shiftRecordBreakDTO'
import TimesheetAddedModel from './timesheetAddedModel'

/**
 * @typedef {ShiftRecordAddedCommentType & TimesheetAddedModel} ShiftRecordAddedCommentTypeExtended
 */

/**
 * @class
 */
export default class ShiftRecordAddedComment extends TimesheetAddedModel {
  /**
   * Create a new ShiftRecordAddedComment.
   * @param {ShiftRecordAddedCommentTypeExtended} params
   */
  constructor(params) {
    super(params)
    this.breaks =
      params.breaks && params.breaks.length > 0
        ? params.breaks.map((change) => new ShiftRecordBreakDTO(change))
        : []
    this.isRestBreakCompliant = params.isRestBreakCompliant
  }
}
